import Main from '@/views/administracion/perfilusuario/Main.vue';
import Default from '@/views/administracion/perfilusuario/Default.vue';

const perfilUsuario = [
  {
    path: 'mi-perfil',
    meta: {
      title: '',
      auth: [],
    },
    component: Main,
    children: [
      {
        name: 'miPerfil',
        path: '/',
        meta: {
          title: 'Mi Perfil',
          auth: [],
        },
        component: Default,

        children: [],
      },
    ],
  },
];

export default perfilUsuario;
